import { render, staticRenderFns } from "./sameGoods.vue?vue&type=template&id=de390ffe&scoped=true&"
import script from "./sameGoods.vue?vue&type=script&lang=js&"
export * from "./sameGoods.vue?vue&type=script&lang=js&"
import style0 from "./sameGoods.vue?vue&type=style&index=0&id=de390ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de390ffe",
  null
  
)

export default component.exports